import { useCallback } from 'react';
import api from '../../services/api';

const usePlans = () => {
  const getPlanList = useCallback(async (params) => {
    const { data } = await api.request({
      url: '/plans/list',
      method: 'GET',
      params,
    });
    return data;
  }, []);

  const list = async (params) => {
    const { data } = await api.request({
      url: '/plans/all',
      method: 'GET',
      params,
    });
    return data;
  };

  const save = async (data) => {
    const { data: responseData } = await api.request({
      url: '/plans',
      method: 'POST',
      data,
    });
    return responseData;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/plans/${data.id}`,
      method: 'PUT',
      data,
    });
    return responseData;
  };

  const remove = async (id) => {
    const { data } = await api.request({
      url: `/plans/${id}`,
      method: 'DELETE',
    });
    return data;
  };

  const getPlanCompany = useCallback(async (params, id) => {
    const { data } = await api.request({
      url: `/companies/listPlan/${id}`,
      method: 'GET',
      params,
    });
    return data;
  }, []);

  const listAccess = async (planId) => {
    const { data } = await api.request({
      url: `/plans/${planId}/access`,
      method: 'GET',
    });
    return data;
  };

  const addAccess = async (planId, companyId) => {
    const { data } = await api.request({
      url: `/plans/${planId}/access`,
      method: 'POST',
      data: { companyId },
    });
    return data;
  };

  const removeAccess = async (planId, companyId) => {
    const { data } = await api.request({
      url: `/plans/${planId}/access/${companyId}`,
      method: 'DELETE',
    });
    return data;
  };

  return {
    getPlanList,
    list,
    save,
    update,
    remove,
    getPlanCompany,
    listAccess,
    addAccess,
    removeAccess,
  };
};

export default usePlans;
